// Editor Constants and Configuration
// Extracted from EditorPage.js for better maintainability

// CSS Variables matching the published page exactly
export const cssVars = {
  bg: '#FAFAFA',
  bgWhite: '#FFFFFF',
  text: '#1a1a1a',
  textSecondary: '#6b6b6b',
  textMuted: '#999999',
  accent: '#7C3AED',
  accentLight: '#F5F3FF',
  border: '#EBEBEB',
};

export const CARD_TYPES = [
  { type: 'ANNOUNCEMENT', label: 'Announcement', icon: '📢', description: 'Highlighted announcement', isHorizontal: true, defaultContent: { text: '' } },
  { type: 'INVESTMENT_THESIS', label: 'Investment Thesis', icon: '📝', description: 'Your investment philosophy', isHorizontal: true, defaultContent: { text: '' } },
  { type: 'STATS_GRID', label: 'At a Glance', icon: '📊', description: 'Key metrics & stats', isHorizontal: true, defaultContent: { stats: [{ label: 'stat 1', value: '10+' }, { label: 'stat 2', value: '5' }, { label: 'stat 3', value: 'high' }] } },
  { type: 'HOW_I_INVEST', label: 'How I Invest', icon: '💰', description: 'Investment preferences', isHorizontal: true, defaultContent: { 
    lead_follow: [], 
    primary_stage: [], 
    check_size: [], 
    ownership_target: [], 
    hardware_software: [], 
    b2b_b2c: [],
    geo_focus: []
  }},
  { type: 'INVESTMENT_FOCUS', label: 'Investment Focus', icon: '🎯', description: 'Industries & sectors', isHorizontal: true, defaultContent: { 
    invest_in: [], 
    do_not_invest_in: [] 
  }},
  { type: 'POST_INVESTMENT_SUPPORT', label: 'Post-Investment Support', icon: '🤝', description: 'How you help portfolio', isHorizontal: true, defaultContent: { 
    support_areas: [] 
  }},
  { type: 'LINKS', label: 'Links', icon: '🔗', description: 'Newsletter, podcast, etc.', isHorizontal: true },
  { type: 'EMPTY', label: 'Empty Card', icon: '◻️', description: 'Blank card with text, tags & links', isHorizontal: true, defaultContent: { isHorizontal: true, fields: [] } },
  { type: 'CAROUSEL', label: 'Carousel', icon: '▢', description: 'Scrolling showcase of links/images', isHorizontal: true, defaultContent: { items: [] } },
  { type: 'ADVICE', label: 'Advice', icon: '💡', description: 'Share your wisdom', defaultContent: { text: 'Your advice here...' } },
  { type: 'JOURNEY_TIMELINE', label: 'Journey', icon: '🛤️', description: 'Career timeline', defaultContent: { items: [{ company: 'Company', role: 'Role', is_current: true }] } },
  { type: 'CONTENT_LIST', label: 'Content', icon: '📚', description: 'Books, podcasts, etc.', defaultContent: { items: [{ type: 'book', name: 'Book Title' }] } },
  { type: 'OUTSIDE_OF_WORK', label: 'Personal', icon: '☀️', description: 'Life outside work', defaultContent: { items: [{ icon: '', text: 'Hobby or interest' }] } },
  { type: 'QUOTE', label: 'Quote', icon: '💬', description: 'Favorite quote', defaultContent: { text: 'Your favorite quote...', author: '' } },
  { type: 'HIGHLIGHTS', label: 'Highlights', icon: '⭐', description: 'Key achievements', defaultContent: { items: ['Achievement 1', 'Achievement 2'] } },
];

// Investment card options
export const INVEST_OPTIONS = {
  lead_follow: ['Lead', 'Mostly Lead', 'Co-Lead', 'Follow', 'Mostly Follow', 'Either'],
  primary_stage: ['Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C+', 'Growth'],
  can_also_enter: ['Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C+', 'Growth', '-'],
  check_size: ['<$100K', '$100K-$500K', '$500K-$1M', '$1M-$2M', '$2M-$5M', '$5M-$10M', '$10M+'],
  ownership_target: ['<5%', '5-10%', '10-15%', '15-20%', '20%+', 'Flexible'],
  hardware_software: ['Software Only', 'Hardware Only', 'Agnostic', 'Software Preferred'],
  b2b_b2c: ['B2B', 'B2C', 'B2B2C', 'Agnostic', '-'],
  geo_focus: ['US Only', 'North America', 'Europe', 'Asia', 'Global', 'Emerging Markets'],
  industries: ['AI / ML', 'Data & Analytics', 'Financial Services / Payments', 'Future of Work', 'SaaS', 'Social / Communities', 'Hardware', 'CPG', 'Biotech', 'Crypto / Web3', 'Healthcare', 'CleanTech', 'E-commerce', 'EdTech', 'Gaming', 'Media / Entertainment', 'Robotics', 'SpaceTech', 'Marketplace', 'Enterprise', 'Consumer', 'DeepTech'],
};

// Social profile links (shown under photo)
export const PROFILE_SOCIAL_OPTIONS = [
  { key: 'linkedin_url', label: 'LinkedIn', placeholder: 'https://linkedin.com/in/yourname' },
  { key: 'twitter_url', label: 'Twitter/X', placeholder: 'https://twitter.com/yourhandle' },
  { key: 'github_url', label: 'GitHub', placeholder: 'https://github.com/yourname' },
  { key: 'instagram_url', label: 'Instagram', placeholder: 'https://instagram.com/yourhandle' },
];

// Content links (shown in "links" card)
export const LINKS_OPTIONS = [
  { key: 'newsletter_url', label: 'My Newsletter', placeholder: 'https://newsletter.example.com' },
  { key: 'podcast_url', label: 'My Podcast', placeholder: 'https://podcast.example.com' },
  { key: 'course_url', label: 'My Course', placeholder: 'https://course.example.com' },
];

// Tag color palette - vibrant but professional colors
export const TAG_COLORS = [
  { bg: '#DBEAFE', text: '#1E40AF' }, // Blue
  { bg: '#D1FAE5', text: '#065F46' }, // Green
  { bg: '#FEE2E2', text: '#991B1B' }, // Red
  { bg: '#E0E7FF', text: '#3730A3' }, // Indigo
  { bg: '#FCE7F3', text: '#9D174D' }, // Pink
  { bg: '#FEF3C7', text: '#92400E' }, // Amber
  { bg: '#CFFAFE', text: '#155E75' }, // Cyan
  { bg: '#F3E8FF', text: '#6B21A8' }, // Purple
  { bg: '#ECFCCB', text: '#3F6212' }, // Lime
  { bg: '#FFEDD5', text: '#9A3412' }, // Orange
];

// Pre-defined tag suggestions by category
export const TAG_SUGGESTIONS = {
  investment: ['AI/ML', 'SaaS', 'Fintech', 'Healthcare', 'B2B', 'B2C', 'Seed', 'Series A', 'Climate', 'Crypto'],
  skills: ['Leadership', 'Strategy', 'Product', 'Engineering', 'Marketing', 'Sales', 'Operations', 'Finance'],
  interests: ['Reading', 'Travel', 'Music', 'Sports', 'Art', 'Technology', 'Cooking', 'Photography'],
  general: ['Featured', 'New', 'Updated', 'Popular', 'Recommended', 'Must-read', 'Favorite', 'Essential']
};

// Get consistent color for a tag based on its text
export const getTagColor = (tag) => {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = tag.charCodeAt(i) + ((hash << 5) - hash);
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
};

// Map card types to section IDs for horizontal order management
export const HORIZONTAL_TYPE_MAP = {
  'HOW_I_INVEST': 'howIInvest',
  'INVESTMENT_FOCUS': 'investmentFocus',
  'POST_INVESTMENT_SUPPORT': 'postInvestment',
  'STATS_GRID': 'stats',
  'ANNOUNCEMENT': 'announcement',
  'INVESTMENT_THESIS': 'investmentThesis',
  'CAROUSEL': 'carousel'
};

// Default horizontal order
export const DEFAULT_HORIZONTAL_ORDER = ['announcement', 'carousel', 'investmentThesis', 'stats', 'connect', 'howIInvest', 'investmentFocus', 'postInvestment'];
